import { CookieService } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { InputCheckbox } from '@sm360/widget-commons-forms';

import './CompareButton.scss';

const categoryLabels = {
    new: { cookieName: 'newInventoryCars', compareType: 'new-inventory' },
    catalog: { cookieName: 'newCars', compareType: 'catalog' },
    used: { cookieName: 'usedCars', compareType: 'used' },
};

const CompareButton = ({ vehicleId, categoryName, extraClasses }) => {
    const { cookieName, compareType } = categoryLabels[categoryName];

    const add = LocaleService.t('COMPARE.ADD');
    const remove = LocaleService.t('COMPARE.REMOVE');

    const compareCookieValues = CookieService.get(cookieName);
    const [isActive, setIsActive] = useState(
        compareCookieValues !== undefined && compareCookieValues.includes(vehicleId)
    );

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsActive((curr) => !curr);
    };
    return (
        <div className={`li-compareButton ${extraClasses}`}>
            <a
                data-comparetool-trigger=""
                data-comparetool-type={compareType}
                data-comparetool-trimid={vehicleId}
                role="button"
                aria-label="compare-vehicle"
                onClick={handleClick}
                tabIndex={0}
            >
                <InputCheckbox label={isActive ? remove : add} isSelected={isActive} />
            </a>
        </div>
    );
};

CompareButton.propTypes = {
    vehicleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    categoryName: PropTypes.oneOf(['new', 'used', 'catalog']).isRequired,
    extraClasses: PropTypes.string,
};

CompareButton.defaultProps = {
    extraClasses: '',
};

export default CompareButton;
